import { TPAComponentProps } from '../../../types';

export interface TabItem {
  /** Title id for a11y */
  id?: string;
  /** Title of the tab */
  title?: string;
  /** URL if tab is link */
  href?: string;
  /** Target for link */
  target?: string;
  /** Rel for link */
  rel?: string;
  /** Element, usually and icon, to be rendered infront of title */
  prefix?: React.ReactNode;
  /** Element, usually and icon, to be rendered after title */
  suffix?: React.ReactNode;
}

export interface TabProps extends TPAComponentProps {
  item: TabItem;
  index: number;
  isActive: boolean;
  isFocusable: boolean;
  indicateActive: boolean;
  onClick(index: number, e: React.BaseSyntheticEvent): void;
  isTabDiv?: boolean;
}

export type TabType = 'Div' | 'Link' | 'Anchor';
